module.exports = __webpack_public_path__ + "img/phone.c9cba753.svg";